import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { QrCode, AlertTriangle } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Logo } from "../components/Brand";

export default function QRLanding() {
  const { tableCode } = useParams();
  const navigate = useNavigate();
  const { setTable } = useCart();
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/public/table/${tableCode}`)
      .then((r) => { setTable(r.data); setTimeout(() => navigate("/order"), 900); })
      .catch(() => setError("Invalid or expired table QR."));
  }, [tableCode]);

  return (
    <div className="min-h-screen bg-[#08183A] flex flex-col items-center justify-center px-6">
      <Logo size="lg" />
      {!error ? (
        <div className="mt-10 flex flex-col items-center" data-testid="qr-landing-loading">
          <div className="h-16 w-16 rounded-2xl gold-gradient flex items-center justify-center pulse-gold">
            <QrCode className="text-slate-950" size={30} />
          </div>
          <p className="mt-5 text-slate-300">Table <span className="gold-text font-bold">{tableCode}</span> detected…</p>
          <p className="text-xs text-slate-500 mt-1">Loading your food court</p>
        </div>
      ) : (
        <div className="mt-10 flex flex-col items-center text-center" data-testid="qr-landing-error">
          <AlertTriangle className="text-red-400" size={40} />
          <p className="mt-4 text-slate-300">{error}</p>
          <button onClick={() => navigate("/")} className="gold-btn rounded-xl px-6 py-2.5 mt-5 text-sm">Go Home</button>
        </div>
      )}
    </div>
  );
}
